import { useState } from 'react';

const AnalyzeReportWrite = ({
  id,
  detailRef,
  onChangeDetailRef,
  isReadOnly,
}) => {
  const [valueObj, setValueObj] = useState({ ...detailRef });

  const onChangeValueObj = (model, value) => {
    setValueObj({ ...valueObj, [model]: value });
    onChangeDetailRef(valueObj.index, model, value);
  };

  return (
    <>
      {valueObj.taskBsc ? (
        <div className="tbl-wrap" style={{ marginBottom: '2rem' }}>
          <div className="tbl-scroll-box">
            <table className="tbl row data">
              <tbody>
                <tr>
                  <th rowSpan="2" style={{ width: '65px' }}>
                    작업
                    <br /> 부하
                    <br /> 및<br /> 빈도
                  </th>
                  <th className="bg1" style={{ width: '65px' }}>
                    부하
                  </th>
                  <td>
                    <div
                      className="chk-area"
                      style={{ gap: 'var(--krds-spacer-4)' }}
                    >
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workLoad' + id}
                          id={`${true}_rdo1_ans1_${id}`}
                          value="VE"
                          checked={valueObj.taskBsc.workLoad === 'VE'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${true}_rdo1_ans1_${id}`}>
                          매우 쉬움
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workLoad' + id}
                          id={`${true}_rdo1_ans2_${id}`}
                          value="E"
                          checked={valueObj.taskBsc.workLoad === 'E'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${true}_rdo1_ans2_${id}`}>쉬움</label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workLoad' + id}
                          id={`${true}_rdo1_ans3_${id}`}
                          value="LH"
                          checked={valueObj.taskBsc.workLoad === 'LH'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${true}_rdo1_ans3_${id}`}>
                          약간 힘듦
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workLoad' + id}
                          id={`${true}_rdo1_ans4_${id}`}
                          value="H"
                          checked={valueObj.taskBsc.workLoad === 'H'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${true}_rdo1_ans4_${id}`}>힘듦</label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workLoad' + id}
                          id={`${true}_rdo1_ans5_${id}`}
                          value="VH"
                          checked={valueObj.taskBsc.workLoad === 'VH'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${true}_rdo1_ans5_${id}`}>
                          매우 힘듦
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="bg1" style={{ width: '65px' }}>
                    빈도
                  </th>
                  <td>
                    <div
                      className="chk-area"
                      style={{ gap: 'var(--krds-spacer-4)' }}
                    >
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workFreq' + id}
                          id={`${false}_rdo2_ans1_${id}`}
                          value="ETM"
                          checked={valueObj.taskBsc.workFreq === 'ETM'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${false}_rdo2_ans1_${id}`}>
                          3개월마다(년2~3회)
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workFreq' + id}
                          id={`${false}_rdo2_ans2_${id}`}
                          value="EWOTT"
                          checked={valueObj.taskBsc.workFreq === 'EWOTT'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${false}_rdo2_ans2_${id}`}>
                          가끔(하루 또는 주 2~3일)
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workFreq' + id}
                          id={`${false}_rdo2_ans3_${id}`}
                          value="EDBFH"
                          checked={valueObj.taskBsc.workFreq === 'EDBFH'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${false}_rdo2_ans3_${id}`}>
                          자주(1일 4시간)
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workFreq' + id}
                          id={`${false}_rdo2_ans4_${id}`}
                          value="EDOFH"
                          checked={valueObj.taskBsc.workFreq === 'EDOFH'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${false}_rdo2_ans4_${id}`}>
                          계속(1일 4시간 이상)
                        </label>
                      </div>
                      <div className="form-check sm">
                        <input
                          type="radio"
                          name={'workFreq' + id}
                          id={`${false}_rdo2_ans5_${id}`}
                          value="EDOEH"
                          checked={valueObj.taskBsc.workFreq === 'EDOEH'}
                          disabled={true}
                          className={'readOnly'}
                        />
                        <label htmlFor={`${false}_rdo2_ans5_${id}`}>
                          초과근무 시간(1일 8시간 이상)
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
      <div className="data-table">
        <table>
          <caption></caption>
          <tbody>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 근본원인
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id={'humanFactor' + id}
                  name="humanFactor"
                  disabled={isReadOnly}
                  className={isReadOnly ? 'readOnly' : ''}
                  checked={valueObj.anlsPrYn === 'Y'}
                  onChange={e => {
                    onChangeValueObj('anlsPrYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor={'humanFactor' + id}>인적 요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id={'materialFactor' + id}
                  name="materialFactor"
                  disabled={isReadOnly}
                  className={isReadOnly ? 'readOnly' : ''}
                  checked={valueObj.anlsPhyYn === 'Y'}
                  onChange={e => {
                    onChangeValueObj('anlsPhyYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor={'materialFactor' + id}>물적·설비적 요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id={'environFactor' + id}
                  name="environFactor"
                  disabled={isReadOnly}
                  className={isReadOnly ? 'readOnly' : ''}
                  checked={valueObj.anlsEnvYn === 'Y'}
                  onChange={e => {
                    onChangeValueObj('anlsEnvYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor={'environFactor' + id}>환경적 요인</label>
              </td>
            </tr>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 현황 및 문제점
                <br />({valueObj.anlsCn ? valueObj.anlsCn.length : 0} / 4000)
              </td>
              <td colSpan={3}>
                <textarea
                  aria-label="현황 및 문제점"
                  className="form-control sm"
                  style={{ height: '20rem', lineHeight: '1.5' }}
                  value={valueObj.anlsCn}
                  required={true}
                  readOnly={isReadOnly}
                  maxLength={4000}
                  onChange={e => {
                    onChangeValueObj('anlsCn', e.target.value);
                  }}
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AnalyzeReportWrite;
